import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubIcon } from "../HubIcon";

const RoutingRenderElement = ({
  label,
  material,
  departmentOrder,
  isSubRoute,
}) => {
  const sx = { fontSize: "12px !important" };
  return (
    <Stack direction="row" gap="5px" alignItems="center">
      {isSubRoute && <HubIcon icon="CornerDownRight" size="12px !important" />}
      <Typography sx={sx}>{label}</Typography>
      {material && (
        <Typography
          sx={{ ...sx, color: "hubColors.mainFocus", fontWeight: 500 }}
        >
          {material}
        </Typography>
      )}
      {departmentOrder && (
        <Typography
          sx={{ ...sx, color: "hubColors.mainFocus", fontWeight: 500 }}
        >
          # {departmentOrder}
        </Typography>
      )}
    </Stack>
  );
};

export default RoutingRenderElement;
